import { computed } from 'vue';
import { useRoute } from '#app/composables/router';
import { useStore } from '#imports';

/**
 * A page is currently active outside of rendering itself, for example being open in the page builder.
 */
export function useCurrentPageNotRendered() {
	const store = useStore();
	const route = useRoute();

	const currentPageNotRendered = computed(() => route.params.pageId ? store.MonospacePage.peekFirst(route.params.pageId as string) : null);

	return {
		currentPageNotRendered,
	};
}
